import React from 'react';
import { getClientImageURL } from '../../../common/getClientImageURL';
import { useSolution } from '../contexts/solution';
import style from './app-icon.scss';
export function AppIcon() {
    const solution = useSolution();
    const { icon, name } = solution;
    return (React.createElement("img", { alt: `${name} icon`, src: getClientImageURL(icon, {
            toHeight: 42,
            toWidth: 42,
        }), className: style.icon }));
}
//# sourceMappingURL=AppIcon.js.map